module.exports = __webpack_public_path__ + "static/home-illustration-657b04bf66dc8885822efba34aeeba49.png";